/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: c0482804e2bf
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import { EventType, EventType$zodSchema } from "./eventtype.js";
import {
  TriggerListResponse,
  TriggerListResponse$zodSchema,
} from "./triggerlistresponse.js";

export type ListTriggerGlobals = { cloud_name?: string | undefined };

export const ListTriggerGlobals$zodSchema: z.ZodType<ListTriggerGlobals> = z
  .object({
    cloud_name: z.string().describe(
      "The cloud name of your product environment.",
    ).optional(),
  });

export type ListTriggerRequest = { event_type?: EventType | undefined };

export const ListTriggerRequest$zodSchema: z.ZodType<ListTriggerRequest> = z
  .object({
    event_type: EventType$zodSchema.optional().describe(
      "The type of event that will trigger the notification response.",
    ),
  });

export type ListTriggerResponse = TriggerListResponse | ApiError;

export const ListTriggerResponse$zodSchema: z.ZodType<ListTriggerResponse> = z
  .union([
    TriggerListResponse$zodSchema,
    ApiError$zodSchema,
  ]);
